import { NavLink } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';

export default function Sidebar({ open, onNavigate }) {
  const { user } = useAuth();
  const [version, setVersion] = useState(null);

  useEffect(() => {
    const base = process.env.REACT_APP_API_URL || '';
    fetch(`${base}/api/version`)
      .then((r) => r.ok ? r.json() : null)
      .then((data) => data && setVersion(data))
      .catch(() => {});
  }, []);

  const canEdit = user?.role === 'admin' || user?.role === 'trainer';
  const isAdmin = user?.role === 'admin';
  const isSuperAdmin = user?.role === 'super_admin';
  const isGuest = !user;

  return (
    <nav className={`sidebar${open ? ' sidebar-open' : ''}`}>
      <div className="sidebar-brand">
        <NavLink to={isGuest ? '/free' : '/workouts'} className="sidebar-brand-inner">
          <div className="sidebar-brand-icon">
            <i className="bi bi-lightning-charge-fill" />
          </div>
          <div>
            <div className="sidebar-brand-name">MK Workout</div>
            <div className="sidebar-brand-sub">Trainer Studio</div>
          </div>
        </NavLink>
      </div>

      <div className="sidebar-nav">
        <div className="sidebar-section-label">
          {isGuest ? 'Gratis-Bereich' : (isSuperAdmin ? 'Globale Bibliothek' : 'Trainingsbereich')}
        </div>

        {isGuest && (
          <NavLink
            className={({ isActive }) => `sidebar-nav-item${isActive ? ' active' : ''}`}
            to="/free"
            onClick={onNavigate}
          >
            <i className="bi bi-unlock nav-icon" />
            Umsonst-Workouts
          </NavLink>
        )}

        {!isGuest && (
          <>
            <NavLink
              className={({ isActive }) => `sidebar-nav-item${isActive ? ' active' : ''}`}
              to="/workouts"
              onClick={onNavigate}
            >
              <i className="bi bi-journal-richtext nav-icon" />
              Workouts
              {isSuperAdmin && <span className="ms-auto badge bg-warning text-dark" style={{ fontSize: '0.55rem' }}>Global</span>}
            </NavLink>
            <NavLink
              className={({ isActive }) => `sidebar-nav-item${isActive ? ' active' : ''}`}
              to="/exercises"
              onClick={onNavigate}
            >
              <i className="bi bi-activity nav-icon" />
              Übungen
              {isSuperAdmin && <span className="ms-auto badge bg-warning text-dark" style={{ fontSize: '0.55rem' }}>Global</span>}
            </NavLink>
            {canEdit && (
              <NavLink
                className={({ isActive }) => `sidebar-nav-item${isActive ? ' active' : ''}`}
                to="/media"
                onClick={onNavigate}
              >
                <i className="bi bi-images nav-icon" />
                Medien
              </NavLink>
            )}
          </>
        )}

        {!isSuperAdmin && (
          <>
            {!isGuest && (
              <NavLink
                className={({ isActive }) => `sidebar-nav-item${isActive ? ' active' : ''}`}
                to="/presenter"
                onClick={onNavigate}
              >
                <i className="bi bi-play-circle nav-icon" />
                Präsentieren
              </NavLink>
            )}
            {!isGuest && (
              <NavLink
                className={({ isActive }) => `sidebar-nav-item${isActive ? ' active' : ''}`}
                to="/progress"
                onClick={onNavigate}
              >
                <i className="bi bi-graph-up nav-icon" />
                Fortschritt
              </NavLink>
            )}
            <div className="sidebar-section-label" style={{ marginTop: 8 }}>
              Training Tools
            </div>
            <NavLink
              className={({ isActive }) => `sidebar-nav-item${isActive ? ' active' : ''}`}
              to="/stopwatch"
              onClick={onNavigate}
            >
              <i className="bi bi-stopwatch nav-icon" />
              Stoppuhr
            </NavLink>
            <NavLink
              className={({ isActive }) => `sidebar-nav-item${isActive ? ' active' : ''}`}
              to="/timer"
              onClick={onNavigate}
            >
              <i className="bi bi-hourglass-split nav-icon" />
              Timer
            </NavLink>
            <div className="sidebar-nav-parent">
              <i className="bi bi-collection-play nav-icon" />
              Quick Starts
            </div>
            <NavLink
              className={({ isActive }) => `sidebar-nav-sub-item${isActive ? ' active' : ''}`}
              to="/quick-starts/hiit"
              onClick={onNavigate}
            >
              <span className="sidebar-nav-sub-dot" />
              HIIT
            </NavLink>
            <NavLink
              className={({ isActive }) => `sidebar-nav-sub-item${isActive ? ' active' : ''}`}
              to="/quick-starts/pyramide"
              onClick={onNavigate}
            >
              <span className="sidebar-nav-sub-dot" />
              Pyramide
            </NavLink>
            <NavLink
              className={({ isActive }) => `sidebar-nav-sub-item${isActive ? ' active' : ''}`}
              to="/quick-starts/kampfsport"
              onClick={onNavigate}
            >
              <span className="sidebar-nav-sub-dot" />
              Kampfsport
            </NavLink>
            <NavLink
              className={({ isActive }) => `sidebar-nav-sub-item${isActive ? ' active' : ''}`}
              to="/quick-starts/aufwaermen"
              onClick={onNavigate}
            >
              <span className="sidebar-nav-sub-dot" />
              Aufwärmen
            </NavLink>
            <NavLink
              className={({ isActive }) => `sidebar-nav-sub-item${isActive ? ' active' : ''}`}
              to="/quick-starts/stretching"
              onClick={onNavigate}
            >
              <span className="sidebar-nav-sub-dot" />
              Stretching
            </NavLink>
          </>
        )}

        {isAdmin && (
          <>
            <div className="sidebar-section-label" style={{ marginTop: isSuperAdmin ? 0 : 8 }}>
              Verwaltung
            </div>
            <NavLink
              className={({ isActive }) => `sidebar-nav-item${isActive ? ' active' : ''}`}
              to="/settings/ai"
              onClick={onNavigate}
            >
              <i className="bi bi-robot nav-icon" />
              KI-Konfiguration
            </NavLink>
            <NavLink
              className={({ isActive }) => `sidebar-nav-item${isActive ? ' active' : ''}`}
              to="/settings/sound"
              onClick={onNavigate}
            >
              <i className="bi bi-music-note-beamed nav-icon" />
              Sound / Ton / Musik
            </NavLink>
            <NavLink
              className={({ isActive }) => `sidebar-nav-item${isActive ? ' active' : ''}`}
              to="/settings/general"
              onClick={onNavigate}
            >
              <i className="bi bi-sliders nav-icon" />
              Allgemein
            </NavLink>
          </>
        )}

        {isGuest && (
          <>
            <div className="sidebar-section-label" style={{ marginTop: 8 }}>Konto</div>
            <NavLink
              className={({ isActive }) => `sidebar-nav-item${isActive ? ' active' : ''}`}
              to="/login"
              onClick={onNavigate}
            >
              <i className="bi bi-box-arrow-in-right nav-icon" />
              Anmelden / Upgrade
            </NavLink>
          </>
        )}
      </div>

      {version && (
        <div className="sidebar-version">
          <span>v{version.version}</span>
          <span className="sidebar-version-build">Build {version.build_number}</span>
        </div>
      )}
    </nav>
  );
}
